import store from '@/store';
import { appLocalStorage } from "@/services";

export default function(to, from, next) {
	// console.log('%c [ Store State ] ', 'color:#bada55', store.state);
	// console.log('%c [ getPermissionsList ] ', 'color:#bada55', store.getters.getPermissionsList);

	const { getters, dispatch } = store;
	const { getPermissionsList, authState } = getters;

	dispatch("actionPreloader", true);
	const token = appLocalStorage.getItem("auth-token");

	// console.log('%c [  to  ] ', 'color:#bada55', typeof to, to );
	// console.log('%c [  getPermissionsList  ] ', 'color:#bada55', typeof getPermissionsList, getPermissionsList );

	// console.log('%c [  token  ] ', 'color:#bada55', typeof token, token );

	if (token) {
		if (to.meta.requiresAuth) {
			// console.log('%c [  to.meta.requiresAuth  ] ', 'color:#bada55', typeof to.meta.requiresAuth, to.meta.requiresAuth );
			const perm = getPermissionsList.find((value) => value.name === to.name);
			// console.log('%c [  perm  ] ', 'color:#bada55', typeof perm, perm );
			if (perm && !perm?.selected) {
				// console.log('%c [  404  ] ', 'color:#bada55' );
				next({ path: '*' });
			} else {
				// console.log('%c [  open  ] ', 'color:#bada55' );
				const permissionsSection = to.meta.permissionsSection || to.name;
				dispatch('setPermitToSection', permissionsSection);
			}
		} else if (to.meta.isUserAuth) {
			// next({ path: '/profile' });
			next({ path: '/' });
		}
	} else if (to.meta.requiresAuth) {
		next({ path: '/auth' });
	} else if (to.meta.isUserAuth || to.meta.isPassReset) {
		if (authState) {
			// next({ path: '/profile' });
			next({ path: '/' });
		}
	}

	dispatch("actionPreloader", false);
	next();
}
